export class ReadOnlyCollection<T> {

  protected items: Array<T>;

  constructor(items: Array<T> = []) {
    this.items = items;
  }

  elementAt = (index: number): T | undefined => this.items[index];

  map = <TResult>(convertor: (item: T) => TResult) => this.items.map(convertor);

  get count(): number {
    return this.items.length;
  }

  get first(): T {
    return this.items[0];
  }

  get last(): T {
    return this.items[this.items.length - 1];
  }

  next = (current: T): T | null => {
    const items = this.items;
    const index = items.indexOf(current);
    if (index === -1) {
      return null;
    } else {
      return index + 1 > items.length - 1 ? items[0] : items[index + 1];
    }
  };

  prev = (current: T): T | null => {
    const items = this.items;
    const index = items.indexOf(current);
    if (index === -1) {
      return null;
    } else {
      return index - 1 < 0 ? items[items.length - 1] : items[index - 1];
    }
  };

  * [Symbol.iterator]() {
    for (const item of this.items) {
      yield item;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/ReadOnlyCollection.ts